import { env } from '@/helpers/env'

export const config = {
  hero: {
    enabled: !!env('VUE_APP_HERO_ENABLED', false) && !!env('VUE_APP_HERO_ID'),
    id: env('VUE_APP_HERO_ID', null),
  },
}
